import React, { useState, useEffect } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import formimg from "../Forms/Performance-Appraisal-Templates-1-1013x439 1.svg";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

import axios from "axios";
import SelectForm from "./SelectForm";
import { baseURL } from "../../config";

function AddClusterForm() {
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState(null);

  const handleSubmit = async (values) => {
    setFormData(values); // Store form data before displaying the modal
    setShowModal(true); // Show the confirmation modal
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleConfirmSubmit = async () => {
    try {
      const response = await fetch(`${baseURL}/addcluster`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setFormData(null);
        setShowModal(false);

        window.location.href = "/CreateCluster";
      } else {
        console.error("Form submission failed:", response.statusText);
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  return (
    <>
      <Formik
        initialValues={{
          clustername: "",
        }}
        validationSchema={Yup.object({
          title: Yup.string().required("Cluster name is required"),
        })}
        onSubmit={handleSubmit}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
        }) => (
          <div className="container">
            <h4 className="text-start  pb-2">ADD NEW CLUSTER</h4>
            <div className="col-lg-12  mt-1 m-5">
              <form noValidate onSubmit={handleSubmit}>
                <div className="row mt-3">
                  <div className="col-lg-5 ">
                    <label className="formlabel">
                      Enter Cluster Name <span className="text-danger">*</span>
                      <br />
                      [Please avoid special symbols]
                      <span>
                        <br />
                        Max 40 letters
                      </span>
                    </label>
                    <input
                      type="text"
                      className={`form-control ${
                        touched.clustername && errors.clustername
                          ? "is-invalid"
                          : ""
                      }`}
                      placeholder=""
                      name="clustername"
                      value={values.clustername}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {touched.clustername && errors.clustername ? (
                      <div className="text-danger">{errors.clustername}</div>
                    ) : null}
                  </div>
                </div>
                <div className="col-lg-11 text-end mt-5 pb-3">
                  <Button
                    className="border-0 mt-2 p-1 btn-#8d3523 savebtn"
                    type="submit"
                  >
                    Save
                  </Button>
                  <a className="text-decoration-none " href="/AddClusterbut">
                    {" "}
                    <Button
                      type="button"
                      className="btn cancelbtn ml-2"
                      onClick={() => setShowModal(false)}
                    >
                      Cancel
                    </Button>
                  </a>
                </div>
              </form>
            </div>
          </div>
        )}
      </Formik>

      {/* Confirmation Modal */}
      <div className="col-lg-12">
        <Modal show={showModal} onHide={handleCloseModal}>
          <Modal.Header closeButton>
            <Modal.Title>Confirmation</Modal.Title>
          </Modal.Header>
          <Modal.Body>Do You Want to Add this cluster?</Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={handleConfirmSubmit}>
              Yes
            </Button>
            <Button variant="secondary" onClick={handleCloseModal}>
              No
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
}

export default AddClusterForm;
